/*
 * @Author: llzq
 * @Date: 2021-10-05 14:15:24
 * @Email: liuzhiqiang1@jd.com
 * @LastEditors: llzq
 * @LastEditTime: 2021-10-24 13:48:43
 * @Description:  头部注释
 */
import React, { Component } from 'react'
import ResourceItem from '../../models/resourceItem'
import {Button} from 'antd'
import {ResourceUtil} from '../../../../components/uploadModal/file.type'

interface iProps {
    extraProps: ResourceItem
}

export default class clazzZip extends Component<iProps> {
    downloadFile = () => {
        window.open(this.props.extraProps.playUrl)
    }
    render() {
        let {extraProps} = this.props
        return (
            <div className="clazzZip">
                {extraProps &&
                <>
                    <div className="clazzZip_title">{extraProps?.title}</div>
                    <div className="clazzZip_icon"></div>
                    <div className="clazzZip_size">文件大小：{ResourceUtil.getFileSize(extraProps?.size)}</div>
                    <div className="clazzZip_download">
                        <Button style={{marginLeft: 0}} type="primary" onClick={this.downloadFile}>点击下载</Button>
                    </div>
                </>}
            </div>
        )
    }
}